import { useContext, useEffect } from 'react';
import { useInterval } from './use-interval';
import { useStore } from '@longsien/react-store';
import { parkingAvailabilityStore } from '@/stores/parking-availability';
import { DataContext } from '@/components/providers/data-provider/DataProvider';

const ONE_MINUTE_IN_MS = 1000 * 60;

export const useParkingDataInterval = () => {
  /* eslint-disable-next-line no-unused-vars */
  const [_, setParkingAvailability] = useStore(parkingAvailabilityStore);
  const { portalPreferences } = useContext(DataContext);

  const widgets = portalPreferences?.pages?.widgets;
  const hasParkingWidget =
    Boolean(widgets) &&
    Object.keys(widgets).some((key) => widgets[key].typeId === 10);

  const fetchData = () => {
    if (hasParkingWidget) {
      fetch('https://home.student.monash/public/parkingAvailability.json').then(
        async (response) => {
          const data = await response.json();
          setParkingAvailability(data);
        }
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [hasParkingWidget]);

  useInterval(() => {
    fetchData();
  }, 3 * ONE_MINUTE_IN_MS);
};
